import React from 'react';
import AvatarPicker from '@reveel/components/utils/AvatarPicker'

const avatarField = {
  name: 'avatar',
  renderCustom: (props) => <AvatarPicker key="avatar-picker" {...props} />,
}
export default avatarField
